import React from "react";

export default function StagePageLayout({ stageId, theme, children, style: customStyle }) {
  const style = {
    "--stage-heading-color": theme?.headingColor || "#1d1d1d",
    "--stage-body-color": theme?.bodyColor || "#1d1d1d",
    ...customStyle,
  };
  return (
    <div className={`stage-page stage-page--${stageId}`} style={style}>
      {children}
    </div>
  );
}
